import React from 'react';

import styled from 'styled-components';

import {FormItem} from './BaseFormField';

import type {FormItemProps} from './BaseFormField';

interface Props extends Omit<FormItemProps, 'children'> {
  disabled?: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => unknown;
  value: boolean;
  name: string;
}

export function CheckboxField({
  id,
  name,
  value,
  onChange,
  disabled,
  ...props
}: Props) {
  return (
    <FormItem id={id} {...props}>
      <div className="col-2">
        <div className="form-check">
          <BigCheckboxInput
            id={id}
            name={name}
            disabled={disabled}
            checked={value}
            onChange={onChange}
          />
        </div>
      </div>
    </FormItem>
  );
}

const BigCheckboxInput = styled.input.attrs({
  type: 'checkbox',
})`
  width: 1.5rem;
  height: 1.5rem;
`;
